"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreatePositionTrack = exports.TrackSuccessMessage = exports.TrackErrorType = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const TriggersApi_1 = require("../../../../apis/TriggersApi");
const interface_1 = require("../../../../interface");
const const_1 = require("./../../../../component/const");
const common_business_1 = require("@pionex-web-kit/common-business");
var TrackErrorType;
(function (TrackErrorType) {
    TrackErrorType["no_market_price"] = "no_market_price";
    TrackErrorType["input_callback_range"] = "input_callback_range";
    TrackErrorType["input_callback_rate"] = "input_callback_rate";
    TrackErrorType["input_callback_eq_0"] = "input_callback_eq_0";
    TrackErrorType["input_callback_gt_100"] = "input_callback_gt_100";
    TrackErrorType["active_price_lt_latest"] = "active_price_lt_latest";
    TrackErrorType["active_price_gt_latest"] = "active_price_gt_latest";
    TrackErrorType["callback_price_gt_latest"] = "callback_price_gt_latest";
    TrackErrorType["callback_price_lt_latest"] = "callback_price_lt_latest";
    TrackErrorType["callback_price_gt_active_price"] = "callback_price_gt_active_price";
    TrackErrorType["callback_price_lt_active_price"] = "callback_price_lt_active_price";
    TrackErrorType["input_callback_value_eq_0"] = "input_callback_value_eq_0";
})(TrackErrorType = exports.TrackErrorType || (exports.TrackErrorType = {}));
/**提交回撤订单之后相关的提示信息*/
var TrackSuccessMessage;
(function (TrackSuccessMessage) {
    /**新建成功 */
    TrackSuccessMessage["create_success"] = "create_track_success";
    /**编辑成功 */
    TrackSuccessMessage["edit_success"] = "edit_track_success";
    /**撤销成功 */
    TrackSuccessMessage["cancel_success"] = "cancel_track_success";
    /**不需要显示任何提示信息 */
    TrackSuccessMessage["noop"] = "";
})(TrackSuccessMessage = exports.TrackSuccessMessage || (exports.TrackSuccessMessage = {}));
function getCallbackValue(callbackType, callbackValue) {
    return callbackType === interface_1.TriggerCallBackType.CALLBACK_RATE
        ? new trade_utils_lib_1.SafeDecimal(callbackValue).div(100).toFixed(3, trade_utils_lib_1.SafeDecimal.ROUND_DOWN)
        : callbackValue;
}
/**设置仓位追踪出场 */
function useCreatePositionTrack(props) {
    const { callbackType, callbackValue, activationPrice, toggleActivation = false, form: _form, position, latestPrice, order } = props;
    const { position_side, symbol, position_id } = position || {};
    const fromRef = (0, react_1.useRef)(_form);
    fromRef.current = _form;
    const editMode = !!(order === null || order === void 0 ? void 0 : order.trigger_id);
    (0, react_1.useEffect)(() => {
        const form = fromRef.current;
        if (!form || !callbackType || editMode) {
            return;
        }
        // reset fields
        form.setFieldsValue({
            callbackValue: "",
            activationPrice: "",
            toggleActivation: false,
        });
    }, [callbackType, editMode]);
    const validateField = (0, common_business_1.usePersistFn)((field, value) => {
        // 校验是否存在当前价格
        const curPriceD = new trade_utils_lib_1.SafeDecimal(latestPrice);
        if (curPriceD.eq(0)) {
            return (0, rxjs_1.throwError)(TrackErrorType.no_market_price);
        }
        switch (field) {
            case "callbackValue":
                if (!value) {
                    if (!editMode) {
                        return (0, rxjs_1.throwError)(callbackType === interface_1.TriggerCallBackType.CALLBACK_RANGE
                            ? TrackErrorType.input_callback_range
                            : TrackErrorType.input_callback_rate);
                    }
                    return (0, rxjs_1.of)(true);
                }
                const callbackValueD = new trade_utils_lib_1.SafeDecimal(value);
                if (callbackType === interface_1.TriggerCallBackType.CALLBACK_RATE) {
                    if (callbackValueD.lte(0)) {
                        return (0, rxjs_1.throwError)(TrackErrorType.input_callback_eq_0);
                    }
                    if (callbackValueD.gte(100)) {
                        return (0, rxjs_1.throwError)(TrackErrorType.input_callback_gt_100);
                    }
                }
                else {
                    if (callbackValueD.eq(0)) {
                        return (0, rxjs_1.throwError)(TrackErrorType.input_callback_value_eq_0);
                    }
                    const withActivePrice = toggleActivation && !!activationPrice;
                    const price = new trade_utils_lib_1.SafeDecimal(activationPrice);
                    const activePriceD = withActivePrice && !price.eq(0) ? price : new trade_utils_lib_1.SafeDecimal(latestPrice);
                    if (position_side === interface_1.FuturePositionSide.LONG) {
                        if (activePriceD.sub(callbackValueD).lte(0)) {
                            return (0, rxjs_1.throwError)(withActivePrice ? TrackErrorType.callback_price_gt_active_price : TrackErrorType.callback_price_gt_latest);
                        }
                    }
                }
                break;
            case "activationPrice":
                if (value) {
                    if (!toggleActivation) {
                        return (0, rxjs_1.of)(true);
                    }
                    const activePriceD = new trade_utils_lib_1.SafeDecimal(activationPrice);
                    if (position_side === interface_1.FuturePositionSide.LONG) {
                        if (activePriceD.lte(curPriceD)) {
                            return (0, rxjs_1.throwError)(TrackErrorType.active_price_lt_latest);
                        }
                    }
                    else {
                        if (activePriceD.gte(curPriceD)) {
                            return (0, rxjs_1.throwError)(TrackErrorType.active_price_gt_latest);
                        }
                    }
                }
                break;
            default:
                break;
        }
        return (0, rxjs_1.of)(true);
    });
    const validate = (0, common_business_1.usePersistFn)(() => {
        return validateField("callbackValue", callbackValue).pipe((0, operators_1.mergeMap)(() => validateField("activationPrice", activationPrice)));
    });
    // 获取真正的CallbackValue，当选择按比例时需要除以100
    const realCallbackValue = getCallbackValue(callbackType, callbackValue);
    const checkModified = () => {
        if (!order) {
            return true;
        }
        return callbackType !== order.callback_type || !new trade_utils_lib_1.SafeDecimal(order.callback_value).eq(new trade_utils_lib_1.SafeDecimal(realCallbackValue));
    };
    const willCancelOrder = () => {
        return !callbackValue;
    };
    /**判断是否给出立即成交的提示 */
    const willFilledImmediately = () => {
        if (!order || order.origin_order_state !== interface_1.TriggerOrderState.SUBMITTED || willCancelOrder() || !checkModified()) {
            return false;
        }
        /**
         * 判断逻辑
         * 按照差价
         *
         * 做多
         * 最高价格 - 回撤值 >= 当前价格
         * 做空
         * 最低价格 + 回撤值 <= 当前价格
         *
         * 按照比率
         * 做多
         * 最高价格 - 最高价格*回撤率 >= 当前价格
         * 做空
         * 最低价格 + 最低价格*回撤率 <= 当前价格
         */
        const { callback_type, position_side, trailing_peak } = order;
        const currentPrice = new trade_utils_lib_1.SafeDecimal(latestPrice);
        const callback = new trade_utils_lib_1.SafeDecimal(realCallbackValue);
        const trailingPeak = new trade_utils_lib_1.SafeDecimal(trailing_peak);
        if (callback_type === interface_1.TriggerCallBackType.CALLBACK_RANGE) {
            return position_side === interface_1.FuturePositionSide.LONG
                ? trailingPeak.sub(callback).gte(currentPrice)
                : trailingPeak.add(callback).lte(currentPrice);
        }
        else {
            return position_side === interface_1.FuturePositionSide.LONG
                ? trailingPeak.sub(trailingPeak.mul(callback)).gte(currentPrice)
                : trailingPeak.add(trailingPeak.mul(callback)).lte(currentPrice);
        }
    };
    const submit = () => {
        if (editMode && !checkModified()) {
            return (0, rxjs_1.of)(TrackSuccessMessage.noop);
        }
        return validate().pipe((0, operators_1.mergeMap)(() => {
            const isLong = position_side === interface_1.FuturePositionSide.LONG;
            if (editMode) {
                if (willCancelOrder()) {
                    return (0, TriggersApi_1.deleteTriggerOrder)({
                        symbol: order.symbol,
                        accountType: const_1.FutureAccountType,
                        triggerId: order.trigger_id,
                    }).pipe((0, operators_1.map)(() => TrackSuccessMessage.cancel_success));
                }
                // 编辑条件单
                return (0, TriggersApi_1.modifyTrackOrder)({
                    accountType: const_1.FutureAccountType,
                    symbol: order.symbol,
                    trigger_id: order.trigger_id,
                    callback_value: realCallbackValue,
                }).pipe((0, operators_1.map)(() => TrackSuccessMessage.edit_success));
            }
            const params = {
                accountType: const_1.FutureAccountType,
                symbol,
                type: interface_1.CustomOrderType.CLOSE,
                side: isLong ? interface_1.CustomOrderSide.SELL : interface_1.CustomOrderSide.BUY,
                position_side,
                trigger_position_id: position_id,
                trigger_price_type: interface_1.TriggerPriceType.LAST_PRICE,
                trigger_type: isLong ? interface_1.TriggerType.TRAILING_UP_BACK : interface_1.TriggerType.TRAILING_DOWN_REV,
                callback_type: callbackType,
                callback_value: realCallbackValue,
            };
            if (toggleActivation && activationPrice) {
                params.activation_price = activationPrice;
            }
            return (0, TriggersApi_1.createTriggerOrder)(params).pipe((0, operators_1.map)(() => TrackSuccessMessage.create_success));
        }), (0, operators_1.catchError)((err) => (0, rxjs_1.throwError)(err ? (0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(err) : err)));
    };
    return {
        /**校验用户的输入是否合法 */
        validate,
        /**校验并新建追踪回撤单 */
        submit,
        /**校验某个字段是否合法 */
        validateField,
        /**判断是否需要给出立即成交的提示 */
        willFilledImmediately,
    };
}
exports.useCreatePositionTrack = useCreatePositionTrack;
